import type { InjectionKey, Ref } from 'vue';
type BiometricType = Ref<boolean>;

export const promptBiometricKey: InjectionKey<BiometricType> = Symbol('promptBiometric');
